module.exports = __webpack_public_path__ + "img/pizza-chart.e4ec06db.svg";